const RESPONSE_STATUSES = {
  OK: 'ok',
  FAIL: 'fail',
};

export default RESPONSE_STATUSES;
